import React, { useState } from 'react';
import { Link } from 'react-router-dom';
// import Logo from '../../assets/icons/logo.svg';
import { FacebookGreen, Linkedin,  Instagram, Arrow, YouTube } from '../../assets/icons/index';
import '../../assets/css/layout/footer.css';
import Button from '../elements/button';
import LiveVisitorCounter from '../elements/LiveVisitorCounter';

const Footer = () => {
    const [email, setEmail] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        // Handle newsletter subscription
    };

    return (
        <footer className="footer">
            <div className="footer-container">
                {/* Column 1 */}
                <div className="footer-column">
                    {/* <img src={Logo} alt="E-AquaHealth Logo" className="footer-logo" /> */}
                    E-AquaHealth
                    <p className="footer-description">
                        Empowering aquaculture through innovative health monitoring solutions.
                    </p>
                    <div className="social-icons footer">
                        <a href="https://www.facebook.com/profile.php?id=61578036872635"><img src={FacebookGreen} alt="Facebook" /></a>
                        <a href="https://instagram.com/eaquahealth"><img src={ Instagram} alt="Instagram" /></a>
                        <a href="https://www.linkedin.com/in/e-aqua-health-292779383"><img src={Linkedin} alt="LinkedIn" /></a>
                        <a href="https://youtube.com/@eaquahealth"><img src={YouTube} alt="YouTube" /></a>
                        {/* <a href="#">< img src={Twitter} /></a> */}
                    </div>
                    <form onSubmit={handleSubmit} className="newsletter-form">
                        <h4>Subscribe to our Newsletter</h4>
                        <div className="form-group">
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Enter your email"
                                required
                            />
                            <Button text="Subscribe" type="submit" icon={<img src={Arrow} alt="" className='arrow_up' />}  />
                        </div>
                    </form>
                </div>

                {/* Column 2 */}
                <div className="footer-column">
                    <h3>Quick Links</h3>
                    <ul>
                        <li><Link to="/about">About Us</Link></li>
                        <li><Link to="/download">Download App</Link></li>
                        <li><Link to="/learning">BMP Course</Link></li>
                        <li><Link to="/store">Store</Link></li>
                        <li><Link to="/contact">Contact Us</Link></li>
                        <li><Link to="/privacy">Privacy Policy</Link></li>
                        <li><Link to="/terms">Terms of Use</Link></li>
                        <li><Link to="/vendor-terms">Vendor Agreement</Link></li>
                    </ul>
                </div>

                {/* Column 3 */}
                <div className="footer-column">
                    <h3>Our Services</h3>
                    <ul>
                        <li><Link to="/aqua-doc">Advanced Diagnostics</Link></li>
                        <li><Link to="/doctors">Veterinary Consultation</Link></li>
                        <li><Link to="/learning">Educational Resources</Link></li>
                        <li><Link to="/chat">AI Health Monitoring</Link></li>
                        <li><Link to="/community">Community Forums</Link></li>
                    </ul>
                </div>
            </div>

            <div className="footer-stats">
            <LiveVisitorCounter />
        </div>
            <div className="footer-bottom">
                <p>&copy; {new Date().getFullYear()} E-AquaHealth. All rights reserved.</p>
            </div>

            {/* Floating Chat Button */}
            <Link to="/chat" className="floating-chat-btn">
                <div className="chat-icon">
                    <span className="chat-icon-circle"></span>
                    <span className="chat-label">Béèrè</span>
                </div>
            </Link>
        </footer>
    );
};

export default Footer;